import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import { PortfolioRequest, PortfolioResponse } from '../models';
import { PortfolioApi } from './portfolio-api.token';

export const MOCK_PORTFOLIO_RESPONSE: PortfolioResponse = {
  activeStrategies: [
    {
      apy: {
        baseSupplyApy: 0.0725,
        grossApy: 0.0875,
        managementFee: 0.01,
        netApy: 0.071,
        performanceFee: 0.005,
        rewardsApy: 0.015,
      },
      assetSymbol: 'USDTB',
      priceFeedAssetSymbol: 'USDC',
      assets: 1250,
      assetsAmountUSD: 1250,
      chainName: 'USD',
      decimals: 6,
      grossApy: 0.0875,
      name: 'USDC Position',
      netApy: 0.071,
      projectedAmount: 1338.75,
      realizedYield: 14.25,
      realizedYieldUSD: 14.25,
      shares: 1250,
      userAddress: '0x00000000000000000000000000000000000000AA',
      vaultId: 'vault-2',
    },
  ],
  portfolio: {
    grossApy: 0.0875,
    netApy: 0.071,
    positionValue: 1250,
    projectedAmount: 1338.75,
    realizedYield: 14.25,
  },
};

@Injectable()
export class PortfolioMockService implements PortfolioApi {
  getPortfolio(_request: PortfolioRequest): Observable<PortfolioResponse> {
    return of(MOCK_PORTFOLIO_RESPONSE);
  }
}
